import { render } from "./DynamicAppFeedElement.vue.js?vue&type=template&id=4c063c26!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=template&id=4c063c26"
import script from "./DynamicAppFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppFeedElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c063c26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c063c26', __exports__)) {
    api.reload('4c063c26', __exports__)
  }
  
  module.hot.accept("./DynamicAppFeedElement.vue.js?vue&type=template&id=4c063c26!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=template&id=4c063c26", () => {
    api.rerender('4c063c26', render)
  })

}


export default __exports__